import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  FormControl,
  FormLabel,
  useToast,
  Text,
} from "@chakra-ui/react";

import NotificationService from "../../services/Notification";

import { DateTime } from "luxon";

export const InvoiceMonthModal = ({ isOpen, onClose, data, id, name }: any) => {
  const toast = useToast();

  const [selectedMonth, setSelectedMonth] = useState("");

  function getFormattedDateTime() {
    const now = DateTime.local();
    const formattedDate = now.toFormat("MM/dd/yyyy");

    const formattedTime = now.toFormat("hh:mm a");

    return {
      date: formattedDate,
      time: formattedTime,
    };
  }

  const handleMonthChange = (e: any) => {
    setSelectedMonth(e.target.value);
  };

  const handleSubmit = async () => {
    try {
      const data = {
        notification_id: "66acc01636e860cadfd14505",
        application_type: "EXPERT",
        lead_ids: [id],
        notification_status: "PENDING",
        source: "MANUAL",
        schedule_date: getFormattedDateTime().date,
        schedule_time: getFormattedDateTime().time,
        variable_values: [selectedMonth],
        error: [],
        target: "",
      };
      const response = await NotificationService.createNotifcationEvent(data);

      setSelectedMonth("");

      handleClose();
    } catch (error) {
      toast({
        position: "top",
        title: "Failed to send notification.",
        description:
          "There was an error sending the notification. Please try again later.",
        status: "error",
        duration: 1500,
        isClosable: true,
      });
    }
  };

  const isEmptyData = data.length === 0;
  const handleClose = () => {
    setSelectedMonth("");
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={handleClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select Month </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {isEmptyData ? (
              <Text>No data available</Text>
            ) : (
              <>
                <FormControl>

                  <Select
                    placeholder="Select month"
                    onChange={handleMonthChange}
                    value={selectedMonth}
                  >
                    {data.map((obj: any, index: any) => (
                      <option key={index} value={obj.month}>
                        {obj.text}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </>
            )}
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={handleSubmit}
              disabled={!selectedMonth}
            >
              Send
            </Button>
            <Button variant="ghost" onClick={handleClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
